export enum ScanbodyStage {
    OVERVIEW = 'OVERVIEW',
    DETAIL = 'DETAIL',
    SUBMITTED = 'SUBMITTED',
}
